module.exports = "export default __webpack_public_path__ + &quot;156c5b0e4db25697c6427fd7fb282b25.svg&quot;;"